export default __webpack_public_path__ + "static/media/english-bg-small.cdb6e1e1.webp";